export default "__VITE_ASSET__CVJ5_dFb__"